var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7996_60241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6742 33.832H29.3242V48.707H36.6742V33.832Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5125 30.9167H18.5125V29.9167H17.5125V30.9167ZM12.525 30.9167L12.0394 31.7908C12.1879 31.8734 12.3551 31.9167 12.525 31.9167V30.9167ZM12 30.0417L11.2609 29.3681C11.093 29.5522 11 29.7925 11 30.0417H12ZM33.7391 7.6736C34.1111 7.26541 34.0818 6.63293 33.6736 6.26091C33.2654 5.88889 32.6329 5.91821 32.2609 6.3264L33.7391 7.6736ZM12 30.625H11C11 30.9882 11.1969 31.3228 11.5144 31.4992L12 30.625ZM18.5125 49V30.9167H16.5125V49H18.5125ZM17.5125 29.9167H12.525V31.9167H17.5125V29.9167ZM12.7391 30.7153L33.7391 7.6736L32.2609 6.3264L11.2609 29.3681L12.7391 30.7153ZM13.0106 30.0425L12.4856 29.7508L11.5144 31.4992L12.0394 31.7908L13.0106 30.0425ZM13 30.625V30.0417H11V30.625H13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4875 30.9167H47.4875C47.4875 30.3644 47.9352 29.9167 48.4875 29.9167V30.9167ZM53.475 30.9167L53.9606 31.7908C53.8121 31.8734 53.6449 31.9167 53.475 31.9167V30.9167ZM54 30.0417L54.7391 29.3681C54.907 29.5522 55 29.7925 55 30.0417H54ZM32.2609 7.6736C31.8889 7.26541 31.9182 6.63293 32.3264 6.26091C32.7346 5.88889 33.3671 5.91821 33.7391 6.3264L32.2609 7.6736ZM54 30.625H55C55 30.9882 54.8031 31.3228 54.4856 31.4992L54 30.625ZM47.4875 49V30.9167H49.4875V49H47.4875ZM48.4875 29.9167H53.475V31.9167H48.4875V29.9167ZM53.2609 30.7153L32.2609 7.6736L33.7391 6.3264L54.7391 29.3681L53.2609 30.7153ZM52.9894 30.0425L53.5144 29.7508L54.4856 31.4992L53.9606 31.7908L52.9894 30.0425ZM53 30.625V30.0417H55V30.625H53Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7996_60241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(12 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.30fe8854ec89b593d15c3184d4773bca.svg";
export { ForwardRef as ReactComponent };